export default __webpack_public_path__ + "static/media/ab01.ed28a8e7.jpg";